<style lang="scss" scoped>
</style>

<template>
  <c-select-input v-model="proxy" label="User" :options="options"/>
</template>

<script>
import User from '@/models/user';


export default {
  name: 'diode-user-select',
  props: ['value'],
  computed: {
    proxy: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    options() {
      return User.all().reduce((options, user) => {
        options[user.email] = user.id;
        return options;
      }, {'Unassigned': null});
    }
  }
};
</script>
